import React from 'react';
import { Outlet } from "react-router-dom";
import loadable from '../../utils/loadable';
import './index.less';
// import Header from '../../components/header';
// import Footer from '../../components/footer';

const Header = loadable(() => import('../../components/header'));
const Footer = loadable(() => import('../../components/footer'));

class DefaultLayoutPage extends React.Component {

    componentDidMount() {
    }
    render() {
        return (
            <div className="App">
                <Header />
                <div className='site-main'>
                    <Outlet />
                </div>
                <Footer />
            </div>
        );
    }
}

export default DefaultLayoutPage;
